/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-dinning': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M263.17 104.68l-9-53.66a6 6 0 00-5.91-5h-36.57a6 6 0 00-5.91 5l-8.95 53.68a8 8 0 007.89 9.31H228V246h-23v8h53v-8h-26V114h23.28a8 8 0 007.89-9.32zM204.72 106l8.67-52h33.22l8.68 52zM154 178.27V172a36 36 0 00-36-36H82a36 36 0 00-36 36v6.27A19 19 0 0036 195v43a6 6 0 006 6h4v10h8v-10h92v10h8v-10h4a6 6 0 006-6v-43a19 19 0 00-10-16.73zM66 236H44v-41a10.86 10.86 0 012-6.3 11 11 0 018-4.65c.33 0 .66-.05 1-.05a11 11 0 0111 11zm60 0H74v-24h52zm0-41v13H74v-13a19 19 0 00-19-19c-.34 0-.67 0-1 .05V172a28 28 0 0128-28h36a28 28 0 0128 28v4.05c-.33 0-.66-.05-1-.05a19 19 0 00-19 19zm30 41h-22v-41a11 11 0 0111-11c.34 0 .67 0 1 .05a11 11 0 018 4.65 10.86 10.86 0 012 6.3z"/>'
  }
})
